import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'mood-about-dialog',
  standalone: true,
  imports: [MatButton, MatDialogModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './about-dialog.component.html',
  styleUrl: './about-dialog.component.scss',
})
export class AboutDialogComponent {}
